import { getEnvironment, Environment } from './environment-utils';

// echo endpoint is useful for triggering specific responses from Bot MT
// See: https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsMT?path=/private/Campaign/MT/Source/AdsCopilot/AdsCopilotMT.Library/Clients/AIServiceStreamingClientMock.cs
export const DirectLineEndpoint = {
  PROD: 'https://copilot.api.ads.microsoft.com',
  INT: 'https://copilot.api.sandbox.ads.microsoft.com',
  CI: 'https://copilot-echo.api.sandbox.ads.microsoft.com',
  ECHO: 'https://copilot-echo.api.sandbox.ads.microsoft.com', // ldc2 echo endpoint for testing
};

const ECHO_BOT_SEARCH_PARAM = 'echobot';

export function getDirectLineEndpoint(host = window.location.host, search = window.location.search) {
  const env = getEnvironment(host, search);
  switch (env) {
    case Environment.PROD:
    case Environment.BETAPROD:
    case Environment.TIP:
      return DirectLineEndpoint.PROD;
    case Environment.SI:
    case Environment.BETASI: {
      // check if echobot has been enabled via query string
      const params = new URLSearchParams(search);
      if (params.get(ECHO_BOT_SEARCH_PARAM) === '1') {
        return DirectLineEndpoint.ECHO;
      }

      return DirectLineEndpoint.INT;
    }
    case Environment.CI:
      return DirectLineEndpoint.CI;
    default:
      return DirectLineEndpoint.PROD;
  }
}
